module.exports = __webpack_public_path__ + "static/media/arrows-alt.971cf2b9.svg";